module.exports = __webpack_public_path__ + "img/img1.5d473f99.png";